import { inject, Injectable, OnDestroy } from '@angular/core';
import { AuthenticatorService } from './authenticator.service';
import { FeatureName } from '../model/common';
import { Observable } from 'rxjs';

// Если лимит фичи не задан, значит ее использование не контролируется
const FEATURE_LIMITS: Partial<Record<FeatureName, number>> = {
  //[FeatureName.changeActiveKey]: ,
  //[FeatureName.changeActiveSymbol]: ,
  [FeatureName.changeSymbolsSort]: 3,
  [FeatureName.symbolsSearch]: 3,
  [FeatureName.changeSymbolsWatchlist]: 3,
  [FeatureName.support]: 0,
  [FeatureName.changeAiMenu]: 3,
}
const TOTAL_LIMITS = 10

@Injectable({
  providedIn: 'root'
})
export class RequireAuthService implements OnDestroy {

  private authenticator = inject(AuthenticatorService)

  private sb = this.authenticator.auth$.subscribe(() => this.clearLimits())

  private featureCounts: Partial<Record<FeatureName, number>> = {}
  private totalCount = 0

  ngOnDestroy(): void {
    this.sb.unsubscribe()
  }

  registerFeatureUsage(feature: FeatureName) {
    return new Observable<void>(subscriber => {
      // Если лимит фичи не задан, значит не контролируем ее
      if (this.authenticator.isAuthed || FEATURE_LIMITS[feature] === undefined) {
        // позволяем продолжить
        subscriber.next()
        subscriber.complete()
        return
      }

      this.totalCount++
      this.featureCounts[feature] = (this.featureCounts[feature] ?? 0) + 1

      if ((this.featureCounts[feature] ?? 0) > (FEATURE_LIMITS[feature] ?? 0) || this.totalCount > TOTAL_LIMITS) {
        this.authenticator.login()
        // запрещаем продолжать
        subscriber.error()
        return
      }

      // позволяем продолжить
      subscriber.next()
      subscriber.complete()
    })
  }

  private clearLimits() {
    this.featureCounts = {}
  }

}
